import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'fy',
    fullName: 'Western Frisian',
    nativeName: 'Frysk',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Der komt wat Amazing",
    landing_subtitle: "ArgVoid is in app- en spielûntwikkelingsstudio. Bliuw op 'e hichte, nije dingen komme gau!",
    select_language: "Selektearje Taal",
    search_placeholder: "Sykje talen...",
    terms_title: "Terms of Service",
    policy_title: "Privacybelied",
    cookies_title: "Koekje Belied",
    terms_content: `
        <strong>1. Akseptaasje fan betingsten</strong><br>
        Troch tagong te krijen ta ArgVoid, wurde dizze tsjinstbetingsten akseptearre. As dizze betingsten net ôfpraat binne, moat de tsjinst net brûkt wurde.<br><br>

        <strong>2. Platfoarm Usage</strong><br>
        ArgVoid en har applikaasjes wurde levere "as is" foar ynformative en kreative doelen. De tsjinst moat allinnich brûkt wurde foar wetlike doelen.<br><br>

        <strong>3. Ferbean Conduct</strong><br>
        It eksploitearjen fan kwetsberens fan 'e side, spamming, of besykjen sûnder foech tagong ta de ynfrastruktuer is strikt ferbean.<br><br>

        <strong>4. Disclaimer</strong><br>
        It platfoarm en tsjinsten kinne op elts momint wizige wurde sûnder notice. Gjin garânsje wurdt jûn oangeande de uptime of beskikberens fan de tsjinst.
    `,
    policy_content: `
        <strong>1. Ynformaasje Samling</strong><br>
        It platfoarm fereasket op dit stuit gjin brûkersferifikaasje of oanmeitsjen fan akkounts. Gjin persoanlike identifisearjende ynformaasje (lykas nammen of e-mailadressen) wurdt aktyf sammele fan besikers.<br><br>

        <strong>2. Gebrûk Data</strong><br>
        Basis, anonymisearre analytiken kinne wurde sammele om sideferkear te begripen en de applikaasjes te ferbetterjen. Dizze gegevens binne net keppele oan yndividuele brûkersidentiteiten.<br><br>

        <strong>3. Tsjinsten fan tredden</strong><br>
        Oanbieders fan tredden kinne wurde brûkt foar hosting- en analytyske tsjinsten. De privacypraktiken fan dizze respektivelike providers regelje de anonime gegevens dy't ferwurke binne op har ynfrastruktuer.<br><br>

        <strong>4. Gegevensfeiligens</strong><br>
        Redelijke feiligensmaatregels wurde útfierd om it platfoarm te beskermjen. Gjin metoade fan oerdracht oer it ynternet is lykwols folslein feilich.<br><br>
    `,
    cookies_content: `
        <strong>1. Wat binne cookies en lokale opslach? </strong><br>
        Koekjes en lokale opslach fan browsers binne lytse gegevensbestannen opslein op it apparaat om konfiguraasjefoarkarren te ûnthâlden oer besites.<br><br>

        <strong>2. Gebrûk Doel</strong><br>
        Browser LocalStorage wurdt strikt brûkt om konfiguraasje-ynstellingen op te slaan, lykas: <br>
        - Taalfoarkarren<br>
        - Konfiguraasje fan brûkersynterface (bgl. yndieling as tema-ynstellingen) <br>
        - Tydlike applikaasje cache<br><br>

        <strong>3. Gjin Tracking</strong><br>
        Koekjes en lokale opslach wurde net brûkt foar advertinsjes of trackingdoelen fan tredden. Alle opsleine gegevens binne strikt foar de kearnfunksjonaliteit fan it platfoarm.<br><br>

        <strong>4. Control</strong><br>
        Browsergegevens kinne op elk momint wiske wurde fia de browserynstellingen, dy't alle lokale konfiguraasjes weromsette.
    `,
    cookie_consent_text: "Wy brûke basiskoekjes om te garandearjen dat de webside goed funksjonearret, lykas jo sesje aktyf hâlde, jo taalfoarkar opslaan en oare oanpaste konfiguraasjes.",
    read_policy: "Lês Cookie Policy",
    support_title: "Kontakt Support",
    support_subject_label: "Ûnderwerp",
    support_message_label: "Berjocht",
    support_submit_button: "Stjoer Berjocht",
    support_hint: "Opmerking: Dit sil jo standert e-postapplikaasje iepenje om it berjocht te ferstjoeren.",
    support_success_msg: "Jo e-postapp iepenje ...",
    support_error_msg: "It ferstjoeren fan berjocht mislearre. Besykje it letter nochris.",
    explorer_title: "Ûntdekkingsreizger",
    history_title: "Skiednis",
    animation_title: "Animaasje",
    config_title: "Konfiguraasje",
    tool_mouse: "Selektearje (Ctrl+M)",
    tool_brush: "Borstel (Ctrl+B)",
    tool_brush_mode: "Toggle Mode (Solid / Clear)",
    tool_eraser: "Eraser (Ctrl+E)",
    tool_brush_size: "Brush Grutte oanpasse",
    tool_bucket: "Folje (Ctrl+F)",
    tool_eyedropper: "Pipet",
    tool_grid: "Raster (Ctrl+Shift+B)",
    tool_rotate: "Rotearje (Ctrl+Shift+R)",
    tool_flip_h: "Flip H (Ctrl+Shift+H)",
    tool_flip_v: "Flip V (Ctrl+Shift+V)",
    tool_transpose: "Transpose (Ctrl+Shift+T)",
    label_width: "Breedte",
    label_height: "Hichte",
    label_frames: "Oantal Frames",
    label_animation: "Animation Style",
    label_background_color: "Eftergrûnkleur",
    label_interval: "Tuskenskoft",
    tool_anim_config: "Animation Konfiguraasje",
    label_new_width: "Nije Breedte",
    label_new_height: "Nije hichte",
    label_apply: "Tapasse",
    label_colors: "Kleuren",
    label_size: "Grutte",
    label_tolerance: "Tolerânsje",
    val_horizontal: "Horizontaal",
    val_vertical: "Fertikaal",
    val_sequence: "Folchoarder",
    val_bounce: "Bounce",
    val_random: "Willekeurich",
    val_solid: "Solid",
    val_clear: "Klear",
    action_add_sheet: "Nije blêd",
    action_import: "Ymport",
    action_export: "Eksportearje",
    action_sort_projects: "Sortearje",
    sort_date_old: "Aldste Earste",
    sort_date_new: "Nijste Earste",
    sort_name_az: "Namme (A-Z)",
    sort_name_za: "Namme (Z-A)",
    action_new_sprite: "Nije Sprite",
    action_new_project: "Nij projekt",
    modal_save_all_title: "Bewarje alle wizigingen",
    modal_save_all_desc: "Selektearje de aktiva om te bewarjen:",
    modal_save_selected: "Bewarje selektearre",
    action_saved: "Opslein",
    modal_create_sprite_title: "Meitsje Nije Sprite",
    modal_create_project_title: "Meitsje nij projekt",
    modal_add_sheet_title: "Nije blêd taheakje",
    modal_rename_sheet_title: "Omneame Blêd",
    modal_rename_sprite_title: "Omneame Sprite",
    modal_delete_sprite_title: "Sprite wiskje",
    modal_delete_project_title: "Projekt wiskje",
    modal_delete_sheet_title: "Blêd wiskje",
    placeholder_sprite_name: "Namme",
    placeholder_project_name: "Namme",
    placeholder_sheet_name: "Namme",
    placeholder_new_name: "Nije Namme",
    action_create: "Meitsje",
    action_add: "Add",
    action_rename: "Omneame",
    action_duplicate: "Duplikaat",
    action_delete: "Wiskje",
    action_cancel: "Ofbrekke",
    confirm_delete_sprite: "Binne jo wis dat jo dizze sprite fuortsmite wolle?",
    confirm_delete_project: "Binne jo wis dat jo dit projekt fuortsmite wolle? Alle sprites sille fuortsmiten wurde.",
    confirm_delete_sheet: "Binne jo wis dat jo dit blêd fuortsmite wolle?",
    err_select_sprite: "Selektearje asjebleaft earst in sprite.",
    err_select_project: "Selektearje asjebleaft earst in projekt.",
    err_name_empty: "Namme kin net leech wêze.",
    err_sprite_exists: "In sprite mei dy namme bestiet al.",
    err_project_exists: "In projekt mei dy namme bestiet al.",
    err_no_content: "Gjin ynhâld om te bewarjen.",
    err_no_changes: "Gjin feroarings om te bewarjen.",
    err_delete_last_sheet: "Kin it lêste blêd net wiskje.",
    err_extract_frames: "Koe gjin frames ekstrahearje.",
    err_indexeddb: "Opslaan lokaal mislearre. Jo browser kin IndexedDB net stypje.",
    msg_upload_success: "Upload slagge: {0}",
    msg_upload_failed: "Upload mislearre: {0}",
    msg_save_success: "Bewarje suksesfol.",
    msg_saving: "Besparret...",
    msg_multi_save_result: "{0} aktiva bewarre. {1} mislearrings.",
    menu_title: "Menu",
    menu_save: "Rêde",
    menu_save_all: "Alles bewarje",
    menu_support: "Kontakt Support",
    label_local_storage: "Lokale opslach",
    label_sign_in: "Oanmelde",
    modal_export_title: "Eksportearje Sprite",
    label_filename: "Bestânsnamme",
    label_format: "Formaat",
    action_export_confirm: "Eksportearje",
};

export default translations;
